import { AnyGalleryEntityVersion, Collections } from '@uploadcam/common';
import {
  CollectionReference,
  Firestore,
  Timestamp,
  arrayUnion,
  doc,
  getDoc,
  updateDoc,
} from 'firebase/firestore';
import { getCollectionRef } from '../../../../@harmony/angular';

export interface AddItemsToGalleryResult {
  /** Items that were newly added (not already in the gallery). Empty if all were duplicates. */
  newItemIds: string[];
  /** Items already in the gallery before this call. */
  alreadyPresentItemIds: string[];
}

export class AddItemsToGalleryInteractor {
  private readonly collection: CollectionReference<AnyGalleryEntityVersion>;

  constructor(private readonly db: Firestore) {
    this.collection = getCollectionRef(this.db, Collections.Galleries);
  }

  public async execute(
    galleryId: string,
    itemIds: readonly string[],
  ): Promise<AddItemsToGalleryResult> {
    const docRef = doc(this.collection, galleryId);
    const snap = await getDoc(docRef);
    const existing = new Set(snap.data()?.itemIds ?? []);

    const newItemIds = itemIds.filter((id) => !existing.has(id));
    const alreadyPresentItemIds = itemIds.filter((id) => existing.has(id));

    if (newItemIds.length === 0) {
      return { newItemIds, alreadyPresentItemIds };
    }

    await updateDoc(docRef, {
      itemIds: arrayUnion(...newItemIds),
      updatedAt: Timestamp.now(),
    });

    return { newItemIds, alreadyPresentItemIds };
  }
}
